import { login } from "./api";

/// Render the login screen into #app. On success the page reloads, which boots
/// the main app now that a token is stored. There is no registration: accounts
/// are provisioned server-side, and an account with no password set adopts the
/// password entered on its first successful login.
export function renderLogin(): void {
  const app = document.getElementById("app")!;
  app.innerHTML = "";

  const card = document.createElement("form");
  card.className = "login-card";

  const heading = document.createElement("h1");
  heading.className = "login-title";
  heading.textContent = "Cardlake";

  const userInput = document.createElement("input");
  userInput.className = "login-input";
  userInput.type = "text";
  userInput.placeholder = "Username";
  userInput.autocomplete = "username";

  const passInput = document.createElement("input");
  passInput.className = "login-input";
  passInput.type = "password";
  passInput.placeholder = "Password";
  passInput.autocomplete = "current-password";

  const button = document.createElement("button");
  button.className = "login-button";
  button.type = "submit";
  button.textContent = "Log in";

  const error = document.createElement("div");
  error.className = "login-error";

  card.append(heading, userInput, passInput, button, error);

  const wrapper = document.createElement("div");
  wrapper.className = "login-screen";
  wrapper.append(card);
  app.append(wrapper);

  userInput.focus();

  card.addEventListener("submit", (e) => {
    e.preventDefault();
    error.textContent = "";
    button.disabled = true;
    login(userInput.value.trim(), passInput.value)
      .then(() => {
        // Reload so the app bootstraps with the freshly stored token.
        window.location.reload();
      })
      .catch((err: unknown) => {
        button.disabled = false;
        error.textContent = err instanceof Error ? err.message : "Login failed";
        passInput.value = "";
        passInput.focus();
      });
  });
}
